import { timers } from "jquery";

export default class NewsDetail {
    constructor() {
        this.fetchDomElements();
        this.registerObserver();
        this.registerEventHandler();
    }

    fetchDomElements() {
        this.domElements = {};
        this.domElements.shareIcon = document.querySelector('.lni-share');
        this.domElements.videoPreviewPlayButton = document.querySelector('.newsVideoPreview button');
        this.domElements.videoModal = document.getElementById('newsVideoModal');
    }

    registerObserver() {
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.3
        };

        let observer = new IntersectionObserver((entries) => {
            setTimeout(() => {
                entries[0].target.classList.toggle('visible')
            }, 400);
        }, options);

        observer.observe(this.domElements.shareIcon);
    }

    registerEventHandler() {
        if (this.domElements.videoPreviewPlayButton) {
            this.domElements.videoPreviewPlayButton.addEventListener('click', () => {
            });
        }
    }
}
